<template>
  <v-container fluid grid-list-lg>
    <v-layout wrap>
      <v-flex lg4 sm6 xs12>
        <!-- <v-text-field
          label="Email"
          v-validate="'required|email'"
          v-model="value.email"
          data-vv-name="email"
          :error-messages="errors.collect('email')"
          v-if="mailObligatorio"
        ></v-text-field>
        <v-text-field
          label="Email"
          v-validate="'email'"
          v-model="value.email"
          data-vv-name="email"
          :error-messages="errors.collect('email')"
          v-else
        ></v-text-field> -->
        <v-text-field
          label="Email"
          v-validate="'email'"
          v-model="value.email"
          data-vv-name="email"
          :error-messages="errors.collect('email')"
        ></v-text-field>
      </v-flex>

      <v-flex lg4 sm6 xs12 v-show="!user.esComer">
        <v-text-field
          label="Facebook"
          v-model="value.facebook"
          hint="Dato Opcional"
        ></v-text-field>
      </v-flex>

      <v-flex lg4 sm6 class="hidden-lg-and-down"> </v-flex>

      <v-flex lg4 sm6 xs12 v-show="!user.esComer">
        <v-text-field
          label="Instagram"
          v-model="value.instagram"
          hint="Dato Opcional"
        ></v-text-field>
      </v-flex>

      <v-flex xs12>
        <app-manejo-telefonos
          propName="telefonos"
          :value="value"
        ></app-manejo-telefonos>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {};
  },
  props: {
    value: {
      type: Object,
      required: false,
      default: function () {
        return { email: '', twiter: '', facebook: '', instagram: '' };
      },
    },
    mailObligatorio: {
      type: Boolean,
      required: false,
      default: false,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters(['user', 'DebugModeOn']),
  },
  methods: {
    async validar() {
      console.log(' validar contacto');
      await this.$validator.validateAll();
      if (this.errors.items.length > 0) {
        console.log('validation:');
        console.log(this.errors);
        return;
      }
      return true;
    },
  },
};
</script>
